import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { content } from '../data';

const ContactForm = () => {
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('Tak for din besked! Jeg vender tilbage hurtigst muligt.');
        e.target.reset();
      } else {
        setStatus('Der skete en fejl. Prøv venligst igen senere.');
      }
    } catch (error) {
      setStatus('Der skete en fejl. Prøv venligst igen senere.');
    }
  };

  return (
    <section id="kontakt" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl font-semibold text-slate-900 uppercase mb-8">Kontakt mig i dag</h2>
            <p className="text-slate-600 text-lg mb-12">
              {content.contact.message}
            </p>

            <div className="space-y-8">
              <div className="flex items-start group">
                <div className="flex-shrink-0 bg-[#034b89] p-3 text-white rounded-xl group-hover:scale-110 transition-transform">
                  <Mail size={24} />
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold uppercase text-slate-900">Email</h4>
                  <a href={`mailto:${content.contact.email}`} className="text-slate-600 hover:text-slate-900 transition-colors">
                    {content.contact.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start group">
                <div className="flex-shrink-0 bg-[#034b89] p-3 text-white rounded-xl group-hover:scale-110 transition-transform">
                  <Phone size={24} />
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold uppercase text-slate-900">Telefon</h4>
                  <a href={`tel:${content.contact.phone}`} className="text-slate-600 hover:text-slate-900 transition-colors">
                    {content.contact.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start group">
                <div className="flex-shrink-0 bg-[#034b89] p-3 text-white rounded-xl group-hover:scale-110 transition-transform">
                  <MapPin size={24} />
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold uppercase text-slate-900">Lokation</h4>
                  <p className="text-slate-600">{content.contact.address}</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="bg-slate-50 p-8 md:p-12 shadow-inner border border-slate-100"
          >
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-slate-900 uppercase mb-2">{content.contact.cta_title}</h3>
              <p className="text-slate-600">{content.contact.cta_subtitle}</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Honeypot field */}
              <div className="sr-only absolute" aria-hidden="true">
                <label htmlFor="website_url">Website URL</label>
                <input type="text" name="website_url" id="website_url" tabIndex="-1" />
              </div>

              <div>
                <label htmlFor="name" className="block text-sm font-medium uppercase tracking-wider text-slate-900 mb-2">Navn</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  className="w-full px-4 py-4 bg-white border border-slate-200 focus:border-slate-900 outline-none rounded-xl transition-colors"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium uppercase tracking-wider text-slate-900 mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  className="w-full px-4 py-4 bg-white border border-slate-200 focus:border-slate-900 outline-none rounded-xl transition-colors"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium uppercase tracking-wider text-slate-900 mb-2">Besked</label>
                <textarea
                  name="message"
                  id="message"
                  rows="4"
                  required
                  className="w-full px-4 py-4 bg-white border border-slate-200 focus:border-slate-900 outline-none rounded-xl transition-colors"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold uppercase tracking-widest py-5 rounded-full transition-all"
              >
                Send besked
              </button>

              {status && (
                <div className={`mt-4 p-4 text-center font-semibold ${status.includes('Tak') ? 'text-green-600' : 'text-red-600'}`}>
                  {status}
                </div>
              )}
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
